import Color from '../Color.mjs'
import superMeta from '../_MODULE/metaModuleNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.GOLD,
    codeProp: 'rmUserCode',
    name: '需求域',
    ownerIdProp: 'raId',
    ownerTextProp: 'raName',
    ownerType: 'RA',
    textProp: 'rmName',
    type: 'RM',
}
